var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"top":"","offset-y":"","content-class":"elevation-9","open-on-hover":"","close-delay":"750","close-on-content-click":false,"eager":"","transition":"slide-y-reverse-transition","left":"","nudge-top":"15"}})}
var staticRenderFns = []

export { render, staticRenderFns }